/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import PropTypes from "prop-types";
import { Box, Grid } from "@mui/material";
import WelcomeCard from "./WelcomeCard";

const AuthWrapper = ({ children }) => (
    <Box>
        <Grid container direction='column' justifyContent='flex-end'>
            <Grid item container xs={12} justifyContent='center' alignItems='center'>
                <Grid item xs={8} mt={4}>
                    <WelcomeCard>{children}</WelcomeCard>
                </Grid>
            </Grid>
        </Grid>
    </Box>
);

AuthWrapper.propTypes = {
    children: PropTypes.node,
};

export default AuthWrapper;
